class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.variantIdInput = this.querySelector('.sticky-atc__variant-id');

    this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    this.syncWithMainForm();
    this.initScrollVisibility();
    this.initFooterHide();
  }


  syncWithMainForm() {
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      this.variantIdInput.value = variant.id;
      this.submitButton.toggleAttribute('disabled', !variant.available);
      this.submitButton.querySelector('span').textContent = variant.available
        ? this.submitButton.dataset.addToCartText || 'Add to cart'
        : this.submitButton.dataset.soldOutText || 'Sold out';
    });
  }

  initScrollVisibility() {
    this.classList.add('sticky-atc--visible');

    const targetSelector = this.dataset.observeTarget;
    if (!targetSelector) return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }


  //initFooterHide() {
  //  const footer = document.querySelector('.final-cta');
  //  if (!footer) return;
//
  //  const observer = new IntersectionObserver(
   //   ([entry]) => {
  //      this.classList.toggle('sticky-atc--hidden', entry.isIntersecting);
  //    },
    //  { threshold: 0 }
  //  );
//
  //  observer.observe(footer);
  // }

  initFooterHide() {
    const hideSections = document.querySelectorAll(
      '.final-cta, .hero-product__atc-wrapper, .bundle-savings__button'
    );

    if (!hideSections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const shouldHide = entries.some(entry => entry.isIntersecting);
        this.classList.toggle('sticky-atc--hidden', shouldHide);
      },
      { threshold: 0 }
    );

    hideSections.forEach(section => observer.observe(section));
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

    this.variantIdInput.disabled = false;

    const config = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };

    const formData = new FormData(this.form);

    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : ['cart-drawer', 'cart-icon-bubble']
      );
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message);
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }



        // renderContents() updates the drawer sections and opens the drawer itself.
        this.cart.renderContents(response);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-add-to-cart', cartData: response });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.variantIdInput.disabled = true;
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
      });
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
